const mistakes = [
  { icon: 'ri-computer-line', title: 'Создали LMS — думают, что появилась академия', desc: 'LMS-платформа — это инструмент, а не система. Без методологии, программ и наставников платформа превращается в кладбище курсов, которые никто не проходит.' },
  { icon: 'ri-shopping-cart-2-line', title: 'Купили готовые курсы', desc: 'Типовые курсы не учитывают специфику компании, продукта и процессов. Сотрудники не видят связи с реальной работой и не применяют знания.' },
  { icon: 'ri-user-voice-line', title: 'Нет наставников', desc: 'Без наставников обучение остаётся теорией. Новички долго входят в работу, сотрудники не закрепляют навыки на практике.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Нет системы оценки', desc: 'Невозможно понять, работает ли обучение. Нет данных для корректировки программ и подтверждения ROI.' },
  { icon: 'ri-user-star-line', title: 'Нет внутренних экспертов', desc: 'Компания полностью зависит от внешних тренеров. При смене провайдера теряется преемственность и накопленный опыт.' },
  { icon: 'ri-user-unfollow-line', title: 'Нет поддержки руководителей', desc: 'Руководители не участвуют в обучении и не требуют применения новых навыков. Без их поддержки академия не работает.' },
  { icon: 'ri-line-chart-line', title: 'Нет KPI обучения', desc: 'Обучение не привязано к бизнес-показателям. Руководство воспринимает академию как «центр затрат», а не инвестицию.' },
];

export default function TypicalMistakes() {
  return (
    <section id="mistakes" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Типичные ошибки при создании корпоративной академии
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Эти ошибки превращают корпоративную академию из мощного инструмента развития в бесполезный набор курсов. Избегайте их с самого начала.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-red-50 border border-red-200 rounded-xl p-6">
              <div className="w-11 h-11 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${m.icon} text-lg text-red-500`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{m.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}